/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Duration_BadgeInputs */

const en_event_ad_duration_badge = /** @type {(inputs: Event_Ad_Duration_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DURATION`)
};

const fr_event_ad_duration_badge = /** @type {(inputs: Event_Ad_Duration_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DUREE`)
};

const de_event_ad_duration_badge = /** @type {(inputs: Event_Ad_Duration_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DAUER`)
};

const it_event_ad_duration_badge = /** @type {(inputs: Event_Ad_Duration_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DURATA`)
};

const ru_event_ad_duration_badge = /** @type {(inputs: Event_Ad_Duration_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ПРОДОЛЖИТЕЛЬНОСТЬ`)
};

const es_event_ad_duration_badge = /** @type {(inputs: Event_Ad_Duration_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DURACIÓN`)
};

const zh_cn2_event_ad_duration_badge = /** @type {(inputs: Event_Ad_Duration_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期间`)
};

const ja_event_ad_duration_badge = /** @type {(inputs: Event_Ad_Duration_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`間隔`)
};

const hi_event_ad_duration_badge = /** @type {(inputs: Event_Ad_Duration_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अवधि`)
};

const pt_pt2_event_ad_duration_badge = /** @type {(inputs: Event_Ad_Duration_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DURAÇÃO`)
};

/**
* | output |
* | --- |
* | "DURATION" |
*
* @param {Event_Ad_Duration_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_duration_badge = /** @type {((inputs?: Event_Ad_Duration_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Duration_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_ad_duration_badge(inputs)
	if (locale === "de") return de_event_ad_duration_badge(inputs)
	if (locale === "it") return it_event_ad_duration_badge(inputs)
	if (locale === "ru") return ru_event_ad_duration_badge(inputs)
	if (locale === "es") return es_event_ad_duration_badge(inputs)
	if (locale === "zh-CN") return zh_cn2_event_ad_duration_badge(inputs)
	if (locale === "ja") return ja_event_ad_duration_badge(inputs)
	if (locale === "hi") return hi_event_ad_duration_badge(inputs)
	if (locale === "pt-PT") return pt_pt2_event_ad_duration_badge(inputs)
	return en_event_ad_duration_badge(inputs)
});